import { c as _c } from "react/compiler-runtime";
import { useGroupMembersContext } from "@context-providers/group-members-provider";
import { Box } from "@mui-wrapper";
import { ChangeManagementDialog } from "@pages/project-details/project-overview/change-management/change-management-dialog";
import { PALETTE_VARS } from "@styles/palette-vars";
import { getBottomBorderWithBoxShadow } from "@utils/ui-utils";
/** Opens the dialog from the keyboard: the click bubbles up to the dialog's own click handler */
function onKeyDown(event) {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    event.currentTarget.click();
  }
}

/**
 * Makes its children open the dialog to change the group and project manager of the project,
 * by mouse or keyboard. Needs a `GroupMembersProvider` above it.
 */
export function ChangeManagementTrigger(t0) {
  const $ = _c(10);
  const {
    ariaLabel,
    children
  } = t0;
  const {
    canChangeManagement
  } = useGroupMembersContext();
  const t1 = canChangeManagement ? "button" : undefined;
  const t2 = canChangeManagement ? 0 : undefined;
  const t3 = canChangeManagement ? ariaLabel : undefined;
  const t4 = canChangeManagement ? "dialog" : undefined;
  const t5 = canChangeManagement ? onKeyDown : undefined;
  let t6;
  if ($[0] !== canChangeManagement) {
    t6 = canChangeManagement ? {
      cursor: "pointer",
      "&:hover, &:focus-visible": {
        boxShadow: getBottomBorderWithBoxShadow({
          color: PALETTE_VARS.text.disabled
        })
      },
      "&:focus-visible": {
        outline: "none"
      }
    } : undefined;
    $[0] = canChangeManagement;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== children || $[3] !== t1 || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = <ChangeManagementDialog><Box role={t1} tabIndex={t2} aria-label={t3} aria-haspopup={t4} onKeyDown={t5} sx={t6}>{children}</Box></ChangeManagementDialog>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}